import React from 'react';
import styled from 'styled-components';

import { LocationPin } from '@lt/components/icons-react/userflow';
import { PopularDirectionsOption } from '@lt/api/dist/methods/references/types';
import { TitleBlock, SubtitleBlock, ContainerText, LabelText, IconContainer } from '../styles';

export const PopularDirectionOptions = ({ country, label }: PopularDirectionsOption) => {
  if (!country) return null;
  const { image, name_ru: labelCountry, visa_type_ru } = country;
  return (
    <Row>
      {image && <PopularCountryBackground src={image} />}
      <PopularCountryDescription>
        <TitleBlock>
          <IconContainer>
            <StyledLocationPin />
          </IconContainer>
          <ContainerText>
            <LabelText>
              {label}, {labelCountry}
            </LabelText>
            <SubtitleBlock>{visa_type_ru}</SubtitleBlock>
          </ContainerText>
        </TitleBlock>
      </PopularCountryDescription>
    </Row>
  );
};

const StyledLocationPin = styled(LocationPin)`
  flex: 1;
`;

const PopularCountryBackground = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

const PopularCountryDescription = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 4px 0 0 8px;
  z-index: 1;
`;

const Row = styled.div`
  height: 48px;
`;
